import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Field, Fields, Form, getFormSyncErrors, reduxForm, getFormValues, } from 'redux-form';
import v4 from 'uuid';
import { propFunc, propNumber, propShape, ReduxFormProps, } from '../../../../../helpers/custom-prop-types';
import { openFileNewTab } from '../../../../../helpers/files';
import { onClickSubmitCheckForSyncErrors } from '../../../../../helpers/form';
import { validateAdditionalInformation, validateBudget, validateContact, validateWhatRequest, } from '../../../../../validate/consultation';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
import FieldAdditionalFiles from './FieldAdditionalFiles';
import FieldAdditionalInformation from './FieldAdditionalInformation';
import FieldBudget from './FieldBudget';
import FieldConsiderationEndAt from './FieldConsiderationEndAt';
import FieldContact from './FieldContact';
import FieldRecruitmentType from './FieldRecruitmentType';
import FieldWhatRequest from './FieldWhatRequest';
// 項目選択関連の Field Name
const selectFields = [
    'considerationType',
    'considerationEndYear',
    'considerationEndMonth',
    'budgetType',
    'considerationType',
    'recruitmentType',
];
class ConsultationForm extends Component {
    constructor() {
        super(...arguments);
        this.onClickSubmit = (e) => {
            const { formSyncErrors } = this.props;
            onClickSubmitCheckForSyncErrors(e, Object.keys(formSyncErrors));
        };
        this.onChangeFile = (e) => {
            const { change, formValues: { files: fileValues = [] }, } = this.props;
            const { files } = e.currentTarget;
            if (files.length === 0) {
                return;
            }
            change('files', [...fileValues, { file: files[0], id: v4() }]);
        };
        this.onClickFileLink = (e) => {
            const { value } = e.currentTarget;
            const { formValues: { files: fileValues = [] }, } = this.props;
            const { file } = fileValues.find(({ id }) => id === value) || {};
            openFileNewTab(file);
        };
        this.onClickFileDelete = (e) => {
            const { value } = e.currentTarget;
            const { change, formValues: { files: fileValues = [] }, } = this.props;
            change('files', fileValues.filter(({ id }) => id !== value));
        };
        /**
         * 下書き保存
         * @param fieldName 変更された field の name
         * @param value 変更された field の value
         */
        this.onSaveDraft = (fieldName, value) => {
            var _a, _b, _c, _d, _e, _f;
            const { formValues, initialValues, saveDraft } = this.props;
            const values = Object.assign(Object.assign(Object.assign({}, initialValues), formValues), { [fieldName]: value });
            saveDraft({
                about_meeting_tool: (_a = values.aboutMeetingTool) !== null && _a !== void 0 ? _a : null,
                additional_information: (_b = values.additionalInformation) !== null && _b !== void 0 ? _b : null,
                budget: Number.isInteger(parseInt(values.budget, 10))
                    ? parseInt(values.budget, 10)
                    : null,
                budget_type: parseInt(values.budgetType, 10),
                consideration_end_at: `${values.considerationEndYear}-${values.considerationEndMonth}-01`,
                consideration_type: parseInt(values.considerationType, 10),
                contactable_time_1: (_c = values.contactableTime1) !== null && _c !== void 0 ? _c : null,
                contactable_time_2: (_d = values.contactableTime2) !== null && _d !== void 0 ? _d : null,
                contactable_time_3: (_e = values.contactableTime3) !== null && _e !== void 0 ? _e : null,
                recruitment_type: parseInt(values.recruitmentType, 10),
                what_request: (_f = values.whatRequest) !== null && _f !== void 0 ? _f : null,
            });
        };
        /**
         * 下書き登録（checkbox, select）
         * @param e イベントオブジェクト
         */
        this.onSaveDraftOfCheck = (e) => {
            const { name, value } = e.target;
            if (!selectFields.includes(name)) {
                return;
            }
            this.onSaveDraft(name, value);
        };
        /**
         * 下書き登録（text)
         * @param e イベントオブジェクト
         */
        this.onSaveDraftOfText = (e) => {
            const { name, value } = e.target;
            if ([...selectFields, 'files'].includes(name)) {
                return;
            }
            this.onSaveDraft(name, value);
        };
    }
    componentWillUnmount() {
        const { reset } = this.props;
        if (window.location.pathname !== '/mypage/consultation/confirm') {
            reset();
        }
    }
    render() {
        const { currentMonth, currentYear, handleSubmit } = this.props;
        return (_jsxs(Form, Object.assign({ className: 'consultation_form', onBlur: this.onSaveDraftOfText, onChange: this.onSaveDraftOfCheck, onSubmit: handleSubmit }, { children: [_jsx("div", Object.assign({ className: 'question_list_box' }, { children: _jsxs("ul", Object.assign({ className: 'question_list' }, { children: [_jsx("li", Object.assign({ className: 'question_row row_recruitment' }, { children: _jsx(Field, { component: FieldRecruitmentType, name: 'recruitmentType' }) })), _jsx("li", Object.assign({ className: 'question_row row_consideration' }, { children: _jsx(Fields, { component: FieldConsiderationEndAt, currentMonth: currentMonth, currentYear: currentYear, names: [
                                        'considerationType',
                                        'considerationEndYear',
                                        'considerationEndMonth',
                                    ] }) })), _jsx("li", Object.assign({ className: 'question_row row_what_request' }, { children: _jsx(Field, { component: FieldWhatRequest, name: 'whatRequest', validate: validateWhatRequest }) })), _jsx("li", Object.assign({ className: 'question_row row_budget' }, { children: _jsx(Fields, { component: FieldBudget, names: ['budget', 'budgetType'], validate: validateBudget }) })), _jsx("li", Object.assign({ className: 'question_row row_contactable' }, { children: _jsx(Fields, { component: FieldContact, names: [
                                        'contactableTime1',
                                        'contactableTime2',
                                        'contactableTime3',
                                        'aboutMeetingTool',
                                    ], validate: validateContact }) }))] })) })), _jsxs("div", Object.assign({ className: 'additional_box' }, { children: [_jsx("div", Object.assign({ className: 'additional_box_top' }, { children: _jsx(Field, { component: FieldAdditionalInformation, name: 'additionalInformation', validate: validateAdditionalInformation }) })), _jsx("div", Object.assign({ className: 'additional_box_bottom' }, { children: _jsx(Field, { component: FieldAdditionalFiles, name: 'files', onChangeFile: this.onChangeFile, onClickFileDelete: this.onClickFileDelete, onClickFileLink: this.onClickFileLink }) }))] })), _jsx("div", Object.assign({ className: 'submit_box' }, { children: _jsx(SubmitButton, { className: 'consultation_submit_button', isDisabled: false, isLoading: false, onControlClick: this.onClickSubmit, text: '上記内容で送信する' }) }))] })));
    }
}
ConsultationForm.propTypes = Object.assign({ currentMonth: propNumber().isRequired, currentYear: propNumber().isRequired, formSyncErrors: propShape(), formValues: propShape(), handleSubmit: propFunc().isRequired, saveDraft: propFunc().isRequired }, ReduxFormProps);
ConsultationForm.defaultProps = {
    formSyncErrors: {},
    formValues: {},
};
export const formName = 'ConsultationForm';
const mapStateToProps = (state) => ({
    formSyncErrors: getFormSyncErrors(formName)(state),
    formValues: getFormValues(formName)(state),
});
const enhance = compose(connect(mapStateToProps), reduxForm({
    destroyOnUnmount: false,
    form: formName,
}));
export default enhance(ConsultationForm);
